export const EstadoConvocatoria = Object.freeze({
    ACTIVO: "ACTIVO",
    CERRADO: "CERRADO", 
    CANCELADA:"CANCELADA",
});